import { usePathname } from 'next/navigation';
import { SITE_URL } from '../../../../constants';
import styles from './Article.module.scss';

type SocialBarProps = {
  title: string;
};

const SocialBar = ({ title }: SocialBarProps) => {
  const pathname = usePathname();

  return (
    <div className={styles.socialBar}>
      <p className={styles.socialBar__title}>Share this article</p>
      <div className={styles.socialBar__content}>
        <a
          href={`https://twitter.com/intent/tweet?url=${SITE_URL}${pathname}&mini=true&text=${title.replace(/\*/g, '')}`}
          className={styles.social}
          target='_blank'
          aria-label='Twitter'
          rel='noreferrer'
        >
          <svg>
            <use
              xlinkHref='/media/socials/twitter.svg#twitterSVG'
              href='/media/socials/twitter.svg#twitterSVG'
            />
          </svg>
        </a>
        <a
          href={`https://www.linkedin.com/shareArticle?url=${SITE_URL}${pathname}&mini=true`}
          className={styles.social}
          target='_blank'
          aria-label='LinkedIn'
          rel='noreferrer'
        >
          <svg>
            <use
              xlinkHref='/media/socials/linkedin.svg#linkedinSVG'
              href='/media/socials/linkedin.svg#linkedinSVG'
            />
          </svg>
        </a>
        <a
          href={`https://telegram.me/share/${SITE_URL}?url=${SITE_URL}${pathname}&text=${title.replace(/\*/g, '')}`}
          className={styles.social}
          target='_blank'
          aria-label='Telegram'
          rel='noreferrer'
        >
          <svg>
            <use
              xlinkHref='/media/socials/telegram.svg#telegramSVG'
              href='/media/socials/telegram.svg#telegramSVG'
            />
          </svg>
        </a>
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${SITE_URL}${pathname}&quote=${title.replace(/\*/g, '')}`}
          className={styles.social}
          target='_blank'
          aria-label='Facebook'
          rel='noreferrer'
        >
          <svg>
            <use
              xlinkHref='/media/socials/facebook.svg#facebookSVG'
              href='/media/socials/facebook.svg#facebookSVG'
            />
          </svg>
        </a>
      </div>
    </div>
  );
};

export default SocialBar;
